<template>
  <div class="deactivation" id="deactivation">
    <div class="ui grid container faq">
      <div class="intro-content">
        <p class="path">Frequently Asked Questions > Account Deactivation and Termination</p>
        <h3><span>Account</span> Deactivation <span>and</span> Termination</h3>

        <h4 id="accdt1">Can my TayoCash account be deactivated?</h4>
        <div class="paragraph">
          <p>
            Your TayoCash account can be deactivated based on, but not limited to, the following conditions:
            <ul>
              <li>
                For reasons of dormancy or if your account remains inactive for 24 months from the last transaction date.
              </li>
              <li>
                Any violation or non-compliance with the <a class="link" href="/termsandconditions">Terms and Conditions and Acceptable Use Policy</a>, and <a class="link" href="/privacypolicy">Privacy Policy</a> of TayoCash by the
                Member.
              </li>
              <li>
                Upon reasonable belief that the TayoCash wallet has been used or is being used for fraudulent or illegal activities or in breach of laws,
                rules, or regulations.
              </li>
              <li>
                Upon a written notice of cancellation by the member for any reason whatsoever.
              </li>
            </ul>
          </p>
        </div>

        <h4 id="accdt2">Can my TayoCash account be terminated?</h4>
        <div class="paragraph">
          <p>
            You may request to terminate your account through a written notice of cancellation stating your reason for cancellation. You may email your request to our Customer Care Group at <a class="link" href="mailto:ccg@tayocash.com">ccg@tayocash.com</a>.
          </p>
        </div>

        <h4 id="accdt3">How do I recover my deactivated account?</h4>
        <div class="paragraph">
          <p>
            If you wish to reactivate an expired/deactivated account, you will have to email <a class="link" href="mailto:ccg@tayocash.com">ccg@tayocash.com</a>. A TayoCash Customer Care Representative will contact you through your registered mobile number. A reactivation fee may be charged once the request has been approved.
          </p>
        </div>

        <div class="buttons">
          <a href="/faq/maintenance" class="yellow">BACK</a>
          <a href="/faq/accountsecurity" class="white">NEXT</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'deactivation'
}
</script>

<style scoped lang='scss'>
</style>
